import React from 'react';
import { Navigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { LandingNav } from '../components/landing/LandingNav';
import { Hero } from '../components/landing/Hero';
import { Portals } from '../components/landing/Portals';
import { FlagshipCarousel } from '../components/landing/FlagshipCarousel';
import { ToolCarousel } from '../components/landing/ToolCarousel';
import { Founder, BetaForm, LandingFooter } from '../components/landing/Sections';
import { BODY } from '../components/landing/shared';
import { useAuth } from '../context/AuthContext';
import Dashboard from './Dashboard';

export default function Landing() {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center bg-[#080c14]"><Loader2 className="w-8 h-8 animate-spin text-cyan-400" /></div>;
  if (user) {
    const active = user.role === 'owner' || user.status === 'active';
    if (!active) return <Navigate to="/library" replace />;
    return <Dashboard />;
  }
  return (
    <div className="min-h-screen text-slate-100 selection:bg-cyan-500/30" style={{ background: '#080c14', fontFamily: BODY }} data-testid="landing-page">
      <LandingNav />
      <Hero />
      <Portals />
      <FlagshipCarousel />
      <ToolCarousel />
      <Founder />
      <BetaForm />
      <LandingFooter />
    </div>
  );
}
